import { render, staticRenderFns } from "./DocEditorTabBar.vue?vue&type=template&id=02f711c9&scoped=true&"
import script from "./DocEditorTabBar.vue?vue&type=script&lang=js&"
export * from "./DocEditorTabBar.vue?vue&type=script&lang=js&"
import style0 from "./DocEditorTabBar.vue?vue&type=style&index=0&id=02f711c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f711c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('02f711c9', component.options)
    } else {
      api.reload('02f711c9', component.options)
    }
    module.hot.accept("./DocEditorTabBar.vue?vue&type=template&id=02f711c9&scoped=true&", function () {
      api.rerender('02f711c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/DocEditor/DocEditorTabBar.vue"
export default component.exports